var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobileOrIPad)?_c('v-progress-circular',{staticClass:"centerize",attrs:{"indeterminate":"","color":"primary","size":50}}):_c('Lottie',{staticStyle:{"max-width":"600px"},attrs:{"options":_vm.defaultOptions,"height":400,"renderer":"html"},on:{"animCreated":_vm.handleAnimation}})
}
var staticRenderFns = []

export { render, staticRenderFns }